<template>
  <div id="feedback">
      <div v-show="beforeResult" class="feedback-section">
        <h1 style="color:#41b8e4;">反馈</h1>
      </div>
      <div v-show="beforeResult" class="feedback-section">
        <div>联系方式：</div>
        <a-input v-model="contact" placeholder="请输入您的手机号、邮箱等联系方式" />
      </div>
      <div v-show="beforeResult" class="feedback-section">
        <div>反馈内容：</div>
        <a-textarea
          v-model="content"
          placeholder="反馈内容"
          :auto-size="{ minRows: 5, maxRows: 10 }"
        />
      </div>
      <div v-show="beforeResult" class="feedback-section" style="text-align:right;">
        <a-space size="middle">
          <a-button v-on:click="onBack">取消</a-button>
          <a-button v-on:click="submit" type="primary">提交</a-button>
        </a-space>
      </div>
      <a-result v-show="!beforeResult" status="success" title="已收到您的反馈"
        :sub-title="subTitle">
      <template #extra>
        <a-button v-on:click="onBack" type="primary">
          直接返回
        </a-button>
        <a-button v-on:click="onFeedback">
          继续反馈
        </a-button>
      </template>
    </a-result>
  </div>
</template>

<script>
import axios from 'axios';
var initSubTitle = '本站会尽快处理您提出的问题，如果您留下了有效的联系方式，后续可能会通过您的联系方式告知处理结果。';
export default {
  name: 'Feedback',
  metaInfo() {
    return {
      title: 'Bennu\'s Blog - 反馈与建议',
      meta: [{
        name: 'keywords',
        content: 'feedback, suggest, contact'
      }, {
        name: 'description',
        content: 'Contact me, give Suggestion, feedback & reviews.'
      }]
    };
  },
  data() {
    return {
      contact: '',
      content: '',
      beforeResult: true,
      subTitle: initSubTitle + '5秒后自动返回上一页。'
    };
  },
  mounted() {
    this.onFeedback();
  },
  methods: {
    onFeedback() {
      this.beforeResult = true;
    },
    onBack() {
      this.beforeResult = true;
      this.$router.go(-1);
    },
    submit() {
      if (this.contact === '' || this.content === '') {
        this.$message.error('联系方式与反馈内容均不能为空！');
      } else {
        var self = this;
        axios
          .post(self.GLOBAL.host + '/feedback/submit',
            JSON.stringify({ contact: self.contact, content: self.content, type: 0 }),
            { headers: { 'Content-Type': 'application/json' } })
          .then(response => {
            var res = response.data;
            if (res.code === 1000) {
              self.beforeResult = false;
              var timeout = 5;
              var fader = setInterval(function() {
                timeout -= 1;
                if (timeout > 0) {
                  self.subTitle = initSubTitle + timeout + '秒后自动返回上一页。';
                } else {
                  clearInterval(fader);
                  if (!self.beforeResult) {
                    self.$router.go(-1);
                  }
                }
              }, 1000);
            } else {
              self.$message.error(res.message);
            }
          })
          .catch(function (error) {
            self.$notification.error({
              message: '系统异常',
              description: error
            });
          });
      }
    }
  }
};
</script>

<style scoped>
body {
  margin:0;
  height:auto;
  width:auto;
}

#feedback {
  max-width: 500px;
  margin: 30px auto 0 auto;
}

.feedback-section {
  margin-bottom: 30px;
}
</style>
